import { apiBasic, apiBasicWithPagination } from "./requests";

/**
 * Cart
 * Nota: el backend usa POST para get-customer-carts (lo mantenemos).
 */

export const getCustomerCarts = (data = null, { page = 1, pageSize = 75, state } = {}) => {
  const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
  if (state) params.set("state", state);
  const path = `get-customer-carts?${params.toString()}`;
  return apiBasicWithPagination(data, path, "post").then((response) => {
    // El backend expresa "el cliente no tiene carritos" como un 400. Para el
    // TPV no es un error: equivale a que el cliente empieza con el carrito vacío.
    if (!state && response?.error && response?.message === "No shopping carts found for the user") {
      return {
        error: false,
        data: [],
        pagination: {
          totalCount: 0,
          totalPages: 1,
          currentPage: page,
          pageSize,
        },
      };
    }

    return response;
  });
};

export const addProductToCart = (payload = null) => {
  const path = "add-product-to-cart";
  return apiBasic(payload, path, "post");
};

export const removeProductFromCart = (payload = null) => {
  const path = "remove-product-from-cart";
  return apiBasic(payload, path, "post");
};

export const updateCartProductQuantity = (payload = null) => {
  const path = "update-cart-product-quantity";
  return apiBasic(payload, path, "patch");
};

export const clearCustomerCart = (customerId) => {
  const path = "clear-customer-cart/" + customerId;
  // mejor sin body
  return apiBasic(null, path, "delete");
};

export const addCartShippingAddress = (payload, id) => {
  const path = `shopping-cart/${id}/add-address`;
  return apiBasic(payload, path, "patch");
};

export const addCartNote = (payload, shoppingCartId) => {
  const path = `shopping-cart/${shoppingCartId}/add-note`;
  return apiBasic(payload, path, "patch");
};

export const addCartDiscount = (shoppingCartId, discountId) => {
  const path = `shopping-cart/${shoppingCartId}/discount/${discountId}`;
  return apiBasic(null, path, "post");
};

export const removeCartDiscount = (shoppingCartId, discountId) => {
  const path = `shopping-cart/${shoppingCartId}/discount/${discountId}`;
  return apiBasic(null, path, "delete");
};

/**
 * Direcciones persistentes del cliente.
 * La empresa se resuelve en el backend a partir de la sesión del TPV.
 */
export const getCustomerAddresses = (customerId) => {
  const path = `customers/${customerId}/addresses`;
  return apiBasic(null, path, "get");
};

export const createCustomerAddress = (customerId, address) => {
  const path = `customers/${customerId}/addresses`;
  return apiBasic({ address }, path, "post");
};

export const updateCustomerAddress = (customerId, addressId, address) => {
  const path = `customers/${customerId}/addresses/${addressId}`;
  return apiBasic({ address }, path, "patch");
};

export const deleteCustomerAddress = (customerId, addressId) => {
  const path = `customers/${customerId}/addresses/${addressId}`;
  return apiBasic(null, path, "delete");
};

export const quoteCart = payload => apiBasic(payload, "quote-cart");

export const editTpvCartLine = (shoppingCartId, lineId, payload) =>
  apiBasic(payload, `shopping-cart/${shoppingCartId}/lines/${lineId}`, "patch");

export const getCustomerHistory = (customerId,kind,page=1,excludeCartId) =>
  apiBasic({page,...(kind==='carts'&&excludeCartId?{excludeCartId}:{})},`customers/${customerId}/history/${kind}`,'get');
export const getCustomerHistoryDetail = (customerId,kind,sourceId) =>
  apiBasic(null,`customers/${customerId}/history/${kind}/${sourceId}`,'get');
export const repeatCustomerHistory = (customerId,kind,sourceId,payload) =>
  apiBasic(payload,`customers/${customerId}/history/${kind}/${sourceId}/repeat`,'post');
